import React, { useEffect } from "react";
import "./DropContainer.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faChevronUp } from "@fortawesome/pro-regular-svg-icons";
import Checkbox from "../option/types/checkbox/Checkbox";
import Radio from "../option/types/radio/Radio";
import Toggle from "../option/types/toggle/Toggle";
import { TOptionValue } from "../option/optionsUtils";

export type TDrop = "arrow" | "checkobox" | "radio" | "switch";
export type TDropValue = TOptionValue | "open" | "closed";

interface IProps {
    title: React.ReactNode | undefined;
    description: React.ReactNode | undefined;
    type?: TDrop;
    value?: TDropValue;
    onClick?: (e) => void;
    disabled?: boolean;
    children?: React.ReactNode;
    help?: React.ReactNode;
}

export default function DropContainer(props: IProps) {
    const resolvedType = props.type ?? "arrow";
    const isControlled = props.value !== undefined;
    const [value, setValue] = React.useState<TDropValue>(
        props.value ?? (resolvedType === "arrow" ? "open" : "unselected"),
    );

    const onClick = (e) => {
        e.stopPropagation();
        e.preventDefault();

        if (props.onClick) {
            props.onClick(e);
        }

        if (props.disabled) {
            return;
        }

        if (isControlled) {
            return;
        }

        if (resolvedType === "arrow") {
            setValue((prev) => (prev === "closed" ? "open" : "closed"));
        } else {
            setValue((prev) => (prev === "selected" ? "unselected" : "selected"));
        }
    };

    useEffect(() => {
        if (props.value !== undefined) {
            setValue(props.value);
        }
    }, [props.value]);

    const isOpen = resolvedType === "arrow" ? value !== "closed" : value === "selected";
    const optionValue: TOptionValue =
        value === "indeterminate" ? "indeterminate" : value === "selected" ? "selected" : "unselected";

    return (
        <div
            className={`userful-drop-container noselect ${isOpen ? "userful-drop-container-open" : ""}  ${props.disabled ? "userful-drop-container-disabled" : ""}`}
        >
            <div className="userful-drop-header" onClick={onClick}>
                <div className="userful-drop-text">
                    <h1>{props.title}</h1>
                    <p>{props.description}</p>
                </div>
                {resolvedType === "arrow" && (
                    <div className="userful-drop-icon">
                        <FontAwesomeIcon icon={isOpen ? faChevronUp : faChevronDown} />
                    </div>
                )}
                {resolvedType === "checkobox" && <Checkbox value={optionValue} onClick={onClick} />}
                {resolvedType === "radio" && <Radio value={optionValue} onClick={onClick} />}
                {resolvedType === "switch" && <Toggle value={optionValue} onClick={onClick} />}
            </div>
            {isOpen && props.children && <div className="useful-drop-body">{props.children}</div>}
        </div>
    );
}
